export default "__VITE_ASSET__FE_$bsMv__"